// extracted by mini-css-extract-plugin
export default {"form":"FormClient_form__w-ALt","loading":"FormClient_loading__jvWQI","controls":"FormClient_controls__WeqGb","datepicker":"FormClient_datepicker__ErEBo"};